import { type FC, forwardRef } from 'react';
import { Icon, IconButton as DSIconButton, type IconProps, type IconButtonProps as DSIconButtonProps } from '@eqi-investimentos/react';
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton({
  ariaLabel,
  icon,
  buttonProps,
  iconProps,
  onButtonClick
}, ref) {
  return <DSIconButton ref={ref} onClick={onButtonClick} aria-label={ariaLabel} display="flex" justifyContent="center" alignItems="center" w="fit-content" minW="unset" h="fit-content" icon={<Icon as={icon} focusable="true" {...iconProps} />} bgColor="transparent" _hover={{
    bgColor: 'transparent'
  }} {...buttonProps} />;
});
export type IconButtonProps = {
  ariaLabel: string;
  icon: FC<IconProps>;
  onButtonClick?: () => void;
  buttonProps?: Omit<DSIconButtonProps, 'aria-label'>;
  iconProps?: IconProps;
};